"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.set.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.starts-with.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.promise.js");

var _debug = _interopRequireDefault(require("debug"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _helpers = _interopRequireDefault(require("./helpers"));

var _formatter = _interopRequireDefault(require("../formatter"));

var _operations = _interopRequireDefault(require("./operations"));

var _api = _interopRequireDefault(require("../api"));

var _auth = _interopRequireDefault(require("../auth"));

var _utils = require("../utils");

var _promisify = require("../promisify");

var _middlewares = require("../middlewares");

var _config = _interopRequireDefault(require("../config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var debug = (0, _debug.default)('golos:broadcast');
var formatter = (0, _formatter.default)(_api.default);
var steemBroadcast = {}; // Base transaction logic -----------------------------------------------------

/**
 * Sign and broadcast transactions on the steem network
 */

steemBroadcast.send = /*#__PURE__*/function () {
  var _steemBroadcast$send = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tx, privKeys, callback) {
    var keyMeta, role, str, keys, broadcast, res, transaction, signedTransaction;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            keyMeta = new Set();

            if (!privKeys) {
              _context2.next = 16;
              break;
            }

            _context2.t0 = regeneratorRuntime.keys(privKeys);

          case 3:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 16;
              break;
            }

            role = _context2.t1.value;

            if (!privKeys[role]) {
              _context2.next = 14;
              break;
            }

            str = privKeys[role].toString();

            if (str.startsWith('(')) {
              _context2.next = 12;
              break;
            }

            keyMeta = null;
            return _context2.abrupt("break", 16);

          case 12:
            keys = str.slice(1, -1).split(',');
            keys.forEach(keyMeta.add, keyMeta);

          case 14:
            _context2.next = 3;
            break;

          case 16:
            broadcast = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(signedTransaction) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!_config.default.get('broadcast_transaction_with_callback')) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 3;
                        return _api.default.broadcastTransactionWithCallbackAsync(function () {}, signedTransaction);

                      case 3:
                        _context.t0 = _context.sent;
                        _context.next = 9;
                        break;

                      case 6:
                        _context.next = 8;
                        return _api.default.broadcastTransactionAsync(signedTransaction);

                      case 8:
                        _context.t0 = _context.sent;

                      case 9:
                        res = _context.t0;
                        return _context.abrupt("return", Object.assign(res, signedTransaction));

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function broadcast(_x4) {
                return _ref.apply(this, arguments);
              };
            }();

            _context2.prev = 17;
            res = null;

            if (!keyMeta) {
              _context2.next = 27;
              break;
            }

            tx._meta = {
              _keys: Array.from(keyMeta)
            };
            debug('Broadcasting transaction without signing (transaction, transaction.operations, transaction._meta)', tx, tx.operations, tx._meta);
            _context2.next = 24;
            return (0, _middlewares.mw)().broadcast({
              tx: tx,
              privKeys: privKeys,
              orig: broadcast
            });

          case 24:
            res = _context2.sent;
            _context2.next = 36;
            break;

          case 27:
            _context2.next = 29;
            return steemBroadcast._prepareTransaction(tx);

          case 29:
            transaction = _context2.sent;
            debug('Signing transaction (transaction, transaction.operations)', transaction, transaction.operations);
            signedTransaction = _auth.default.signTransaction(transaction, privKeys);
            debug('Broadcasting transaction (transaction, transaction.operations)', transaction, transaction.operations);
            _context2.next = 35;
            return (0, _middlewares.mw)().broadcast({
              tx: signedTransaction,
              privKeys: privKeys,
              orig: broadcast
            });

          case 35:
            res = _context2.sent;

          case 36:
            if (callback) callback(null, res);
            _context2.next = 42;
            break;

          case 39:
            _context2.prev = 39;
            _context2.t2 = _context2["catch"](17);
            if (callback) callback(_context2.t2, null);

          case 42:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[17, 39]]);
  }));

  function steemBroadcast$send(_x, _x2, _x3) {
    return _steemBroadcast$send.apply(this, arguments);
  }

  return steemBroadcast$send;
}();

steemBroadcast._prepareTransaction = /*#__PURE__*/function () {
  var _steemBroadcast$_prepareTransaction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tx) {
    var props, chainDate, refBlockNum, block, headBlockId;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _api.default.getDynamicGlobalPropertiesAsync();

          case 2:
            props = _context3.sent;
            // Set defaults on the transaction
            chainDate = new Date(props.time + 'Z');
            refBlockNum = props.head_block_number - 3 & 0xFFFF;
            _context3.next = 7;
            return _api.default.getBlockAsync(props.head_block_number - 2);

          case 7:
            block = _context3.sent;
            headBlockId = block.previous;
            return _context3.abrupt("return", Object.assign({
              ref_block_num: refBlockNum,
              ref_block_prefix: new Buffer(headBlockId, 'hex').readUInt32LE(4),
              expiration: new Date(chainDate.getTime() + 60 * 1000)
            }, tx));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  function steemBroadcast$_prepareTransaction(_x5) {
    return _steemBroadcast$_prepareTransaction.apply(this, arguments);
  }

  return steemBroadcast$_prepareTransaction;
}();

steemBroadcast._operations = {}; // Generated wrapper ----------------------------------------------------------
// Generate operations from operations.js

_operations.default.forEach(function (operation) {
  steemBroadcast._operations[operation.operation] = operation;
  var operationName = (0, _utils.camelCase)(operation.operation);
  var operationParams = operation.params || [];
  var useCommentPermlink = operationParams.indexOf('parent_permlink') !== -1 && operationParams.indexOf('parent_permlink') !== -1;

  steemBroadcast["".concat(operationName, "With")] = function steemBroadcast$specializedSendWith(wif, options, callback) {
    debug("Sending operation \"".concat(operationName, "\" with"), {
      options: options,
      callback: callback
    });
    var keys = {};

    if (operation.roles && operation.roles.length) {
      keys[operation.roles[0]] = wif; // TODO - Automatically pick a role? Send all?
    }

    return steemBroadcast.send({
      extensions: [],
      operations: [[operation.operation, Object.assign({}, options, options.json_metadata != null ? {
        json_metadata: toString(options.json_metadata)
      } : {}, useCommentPermlink && options.permlink == null ? {
        permlink: formatter.commentPermlink(options.parent_author, options.parent_permlink)
      } : {})]]
    }, keys, callback);
  };

  steemBroadcast[operationName] = function steemBroadcast$specializedSend(wif) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    debug("Parsing operation \"".concat(operationName, "\" with"), {
      args: args
    });
    var options = operationParams.reduce(function (memo, param, i) {
      memo[param] = args[i]; // eslint-disable-line no-param-reassign

      return memo;
    }, {});
    var callback = args[operationParams.length];
    return steemBroadcast["".concat(operationName, "With")](wif, options, callback);
  };
});

var toString = function toString(obj) {
  return _typeof(obj) === 'object' ? JSON.stringify(obj) : obj;
};

(0, _helpers.default)(steemBroadcast);
(0, _promisify.promisifyAll)(steemBroadcast);
exports = module.exports = steemBroadcast;